'use strict';

import angular from 'angular';
import template from './modal.pug';

function PaymentModalSvc(ModalSvc, LoaderSvc, $http,
  FinTxnSvc, StripeSvc, moment, NewCardModalSvc, NewAccountModalSvc,
  VerifyAccountModalSvc) {
  /**
   * Opens the Financial Transaction - Payment Method Modal
   *  build finTxn for payment submission
   * @param  {Object} selectionObj
   * @return {Object}
   */
  function open(selectionObj) {
    var modalvm = {
      toGroup: selectionObj.toGroup
    };
    var modalInstance = {};
    var groupId = selectionObj.fromGroupId;
    var finTxn = {
      amount: 0,
      fromGroupId: groupId,
      toGroup: selectionObj.toGroup,
      toGroupId: selectionObj.toGroup.id,
      timePeriod: selectionObj.timePeriod,
      timePeriodId: selectionObj.timePeriod.id,
      grpTxn: selectionObj.groupItems,
      // netGrpTxn: { amount: grpAmount }, // appended later
      memTxn: [], // array of objects with person, memTxn: [], netMemTxn: {}
    };

    ////////////////////////////////////////////////////////////////////////////
    ///  Modal Buttons
    ////////////////////////////////////////////////////////////////////////////
    var buttons = [
      {classes: 'btn-primary', text: 'Pay', click: onSubmit, disabled: true},
      {classes: 'btn-default', text: 'Close', click: onCancel}
    ];

    function updatePayText(text) {
      buttons[0].text = text;
    }

    function enablePayButton() {
      buttons[0].disabled = false;
    }

    function disablePayButton() {
      buttons[0].disabled = true;
    }

    ////////////////////////////////////////////////////////////////////////////
    ///  Prep FinTxn and Payment for Display
    ////////////////////////////////////////////////////////////////////////////
    modalvm.displayItems = [];
    finTxn.date = Date.now();
    var description = `${selectionObj.timePeriod.name} Payment to ${selectionObj.toGroup.name}:\n`;

    // sort through group items
    var grpAmount = 0;
    angular.forEach(selectionObj.groupItems, function(item) {
      var amount = item.amount * -1; // negative amounts
      if(amount === 0) { return; }
      description += `${item.name} - $${amount / 100} \n`;
      modalvm.displayItems.push(
        {name: item.name, amount, type: 'Group'}
      );
      // add to group amount total
      grpAmount += amount;
    });
    if(grpAmount !== 0) {
      finTxn.netGrpTxn = { amount: grpAmount };
    }
    finTxn.amount += grpAmount;

    // sort through member items
    angular.forEach(selectionObj.memberItems, function(item) {
      var amount = item.amount * -1; // negative amounts
      if(amount === 0) { return; }
      var personName = '';
      if(item.person) {
        personName += item.person.fname + ' ' + item.person.lname;
      }
      description += `${personName} - $${amount / 100} \n`;
      modalvm.displayItems.push(
        {name: personName, amount, type: 'Membership'}
      );
      finTxn.amount += amount;

      // push to memTxn array
      finTxn.memTxn.push({
        person: item.person,
        netMemTxn: {amount: item.amount * -1}, // negate net amounts
        memTxn: item.itemsUnpaid
      });
    });
    // remove extra new line/comma at end
    if(description.length > 1) {
      description = description.substring(0, description.length - 2);
    }
    finTxn.description = description;

    ////////////////////////////////////////////////////////////////////////////
    ///  Select Payment Method
    ////////////////////////////////////////////////////////////////////////////

    /// increase fee only for Districts (non-Altrusa) credit cards
    var isCCIncreasedbyFee = true;
    if(selectionObj.toGroup.id === 1) {
      isCCIncreasedbyFee = false;
    }

    var processFees = {
      card: {
        fixedFee: 30, // cents
        variableFee: .029, // percentage
        description: 'Credit/Debit Card Fee',
        isIncreasedByFee: isCCIncreasedbyFee
      },
      account: {
        fixedFee: 25, // cents
        variableFee: 0, // percentage
        description: 'Bank Account Fee',
        isIncreasedByFee: false
      }
    };

    modalvm.tabView = {};
    modalvm.setTabView = function(tab) {
      finTxn.type = tab;
      // reset selected cards/accounts
      modalvm.selectedCard = null;
      modalvm.selectedAccount = null;
      _updateProcessFee(processFees[tab]);
      switch (tab) {
      case 'card':
        _initCards();
        updatePayText('Pay with Credit/Debit Card');
        disablePayButton();
        break;
      case 'account':
        _initAccounts();
        updatePayText('Pay with Bank Account');
        disablePayButton();
        break;
      case 'offline':
        updatePayText('Pay Offline');
        enablePayButton();
        break;
      default:
        break;
      }
    };

    modalvm.setTabView('card');

    /**
     * Update financial transaction processing fee
     * @param  {Object}
     *         - fixedFee  fixed fee in cents
     *         - variableFee    percentage for fee (decimals)
     *         - feeText   description of fee
     *
     * TODO:
     *    - Update to append fee amount to financial transaction
     *    - Ensure all values are working in integers
     */
    function _updateProcessFee(feeOptions = {}) {
      var fixedFee = feeOptions.fixedFee || 0;
      var variableFee = feeOptions.variableFee || 0;
      var feeDescription = feeOptions.description || 'Processing Fee';
      var isIncreasedByFee = feeOptions.isIncreasedByFee;
      if(typeof isIncreasedByFee === 'undefined') { isIncreasedByFee = false; }
      // clear old fee if exists
      delete finTxn.feeDescription;
      var paymentAmount;
      var processFeeAmount;
      if(isIncreasedByFee) {
        // increase total payment amount by the fee
        paymentAmount = (fixedFee + finTxn.amount) / (1 - variableFee);
        processFeeAmount = paymentAmount - finTxn.amount;
      } else {
        // default: absorb fee within the payment (less net to group)
        paymentAmount = finTxn.amount;
        processFeeAmount = finTxn.amount * variableFee + fixedFee;
      }
      finTxn.paymentAmount = Math.round(paymentAmount);
      finTxn.processFeeAmount = Math.round(processFeeAmount);
      finTxn.isIncreasedByFee = isIncreasedByFee;
      if(feeDescription && finTxn.processFeeAmount !== 0) {
        finTxn.feeDescription = feeDescription;
      }
      finTxn.paymentAmount = finTxn.amount
        + finTxn.processFeeAmount * isIncreasedByFee;
      finTxn.paymentAmountDisplay = finTxn.paymentAmount / 100;
    }

    ////////////////////////////////////////////////////////////////////////////
    ///  CARD PAYMENTS
    ////////////////////////////////////////////////////////////////////////////
    function _getStripeStatusMessage(paymentIntentResponse) {
      if(!paymentIntentResponse || !paymentIntentResponse.status) {
        return 'Payment Processing Error';
      }
      switch (paymentIntentResponse.status) {
      case 'requires_action':
        return 'Additional authentication is required to complete payment.';
      case 'requires_payment_method':
        return 'Payment was not successful. Please use a different card.';
      case 'processing':
        return 'Payment is still processing. Please check again shortly.';
      case 'canceled':
        return 'Payment was canceled.';
      case 'requires_confirmation':
        return 'Payment confirmation is incomplete. Please try again.';
      case 'requires_capture':
        return 'Payment requires capture and is not finalized.';
      default:
        return `Stripe returned status: ${paymentIntentResponse.status}`;
      }
    }

    function _finalizeCardPayment(cardTxn, paymentIntentId) {
      var finalizePayload = angular.extend({}, cardTxn, {paymentIntentId});
      return FinTxnSvc.finalize({groupId}, finalizePayload).$promise;
    }

    function _submitSavedCardPayment() {
      // Validation: Only allow modern PaymentMethods (pm_ prefix)
      if(!modalvm.selectedCard.id
         || !modalvm.selectedCard.id.startsWith('pm_')) {
        LoaderSvc.stopError('Invalid payment method. Please add a new card.');
        return;
      }

      var cardTxn = angular.extend({}, modalvm.finTxn, {
        source: modalvm.selectedCard.id,
        sourceDisplay: modalvm.selectedCard.display});
      FinTxnSvc.submit({groupId}, cardTxn).$promise
        .then(function(data) {
          if(data.paymentFinalized) {
            return data;
          }

          // Check if 3D Secure authentication is required
          if(data.paymentIntentResponse
             && data.paymentIntentResponse.next_action) {
            if(
              data.paymentIntentResponse.next_action.type === 'use_stripe_sdk'
            ) {
              // Display 3D Secure challenge to user
              updatePayText('Completing 3D Secure Verification...');
              disablePayButton();
              return StripeSvc.handlePaymentAuthentication(
                data.paymentIntentResponse.client_secret
              )
                .then(function(authResult) {
                  return _finalizeCardPayment(cardTxn, authResult.id);
                });
            }
          }

          throw new Error(_getStripeStatusMessage(data.paymentIntentResponse));
        })
        .then(function(data) {
          if(!data.paymentFinalized) {
            throw new Error(
              _getStripeStatusMessage(data.paymentIntentResponse)
            );
          }
          LoaderSvc.stopSuccess('Card Payment Accepted');
          modalInstance.close(data);
        })
        .catch(function(e) {
          var errMsg = 'Payment Processing Error';
          if(e.data && e.data.message) {errMsg = e.data.message; }
          if(e.message) {errMsg = e.message; } // For 3DS auth errors
          LoaderSvc.stopError(errMsg);
          updatePayText('Pay with Credit/Debit Card');
          enablePayButton();
        });
    }

    var currentMonth = Number(moment().format('YYYYMM'));

    // ensure cards are available when tab is selected
    function _initCards() {
      if(!modalvm.cards) { _loadSavedCards(); }
    }

    /**
     * Load cards from server
     * @param  {Object} newCard (optional) new card passed from newCard modal
     */
    function _loadSavedCards(newCard) {
      LoaderSvc.start();
      StripeSvc.indexUserCards().then(function(cards) {
        cards = cards.filter(function(c) {
          // Only allow modern PaymentMethods (pm_ prefix) - no legacy tokens
          if(!c.id || !c.id.startsWith('pm_')) {
            return false;
          }
          // Filter by expiration date using PaymentMethod format
          var expYear = c.card.exp_year;
          var expMonth = c.card.exp_month;
          var dateNumber = expYear * 100 + expMonth;
          return dateNumber >= currentMonth;
        })
          .map(function(c) {
            // Use PaymentMethod format (modern cards only)
            var brand = c.card.brand;
            var last4 = c.card.last4;
            var expMonth = c.card.exp_month;
            var expYear = c.card.exp_year;
            c.display = `${brand} ending in ${last4} (Expires ${expMonth < 10 ? '0' + expMonth : expMonth}/${expYear})`;

            // default payment if new card provided
            if(newCard && newCard.id === c.id) {
              modalvm.selectedCard = c;
              enablePayButton();
            }

            return c;
          });
        cards.push({id: 'new', display: 'Add New Card'});
        modalvm.cards = cards;
        LoaderSvc.stop();
      })
        .catch(function(e) {
          // prevent loading of cards if not available
          console.error('Error loading saved cards:', e);
          modalvm.cardError = true;
          modalvm.setTabView('offline'); // reset default instead of 'cards'
          LoaderSvc.stop();
        });
    }

    modalvm.checkCard = function() {
      // new - open modal
      if(modalvm.selectedCard && modalvm.selectedCard.id === 'new') {
        delete modalvm.selectedCard;
        NewCardModalSvc.open().then(_loadSavedCards);
      }
      // enable pay button
      modalvm.selectedCard ? enablePayButton() : disablePayButton();
    };
    ////////////////////////////////////////////////////////////////////////////
    ///   BANK ACCOUNT PAYMENTS  //////////////////////////////////////////////
    ////////////////////////////////////////////////////////////////////////////
    function _submitSavedAccountPayment() {
      var accountTxn = angular.extend({},
        modalvm.finTxn, {source: modalvm.selectedAccount.id,
          sourceDisplay: modalvm.selectedAccount.display});
      FinTxnSvc.submit({groupId}, accountTxn).$promise
        .then(function(data) {
          if(data.paymentPending) {
            LoaderSvc.stopSuccess('Bank Payment Submitted - Processing');
            modalInstance.close(data);
            return;
          }
          if(!data.paymentFinalized) {
            throw new Error(
              _getStripeStatusMessage(data.paymentIntentResponse)
            );
          }
          LoaderSvc.stopSuccess('Bank Account Payment Accepted');
          modalInstance.close(data);
        })
        .catch(function(e) {
          var errMsg = 'Payment Processing Error';
          if(e.data && e.data.message) {errMsg = e.data.message; }
          LoaderSvc.stopError(errMsg);
        });
    }

    // ensure accounts are available when tab is selected
    function _initAccounts() {
      if(!modalvm.accounts) { _loadSavedAccounts(); }
    }

    /**
     * Load accounts from server
     * @param  {Object} newAccount (optional) new from newAccount modal
     */
    function _loadSavedAccounts(newAccount) {
      LoaderSvc.start();
      StripeSvc.indexUserPaymentMethods().then(function(paymentMethods) {
        const accounts = [];

        // Single pass: filter, normalize, and format in one iteration
        for(let i = 0; i < paymentMethods.length; i++) {
          const pm = paymentMethods[i];

          // Skip non-US bank accounts early
          if(pm.type !== 'us_bank_account' || !pm.us_bank_account) continue;

          // Normalize account data (inline to avoid function call overhead)
          /* eslint-disable camelcase */
          const normalized = {
            id: pm.id,
            bank_name: pm.us_bank_account.bank_name,
            country: pm.us_bank_account.country || 'US',
            last4: pm.us_bank_account.last4,
            status: pm.derived_verification_status || 'unverified',
            source: pm.source,
            setup_intent_id: pm.setup_intent_id,
            setup_intent_status: pm.setup_intent_status,
            source_api_evidence: pm.source_api_evidence
          };
          /* eslint-enable camelcase */

          // Skip unverified and detached accounts
          if(normalized.status === 'verified_but_detached'
             || normalized.status === 'unverified') continue;

          // Add display properties
          let displayStatus;
          switch (normalized.status) {
          case 'verified':
            displayStatus = 'verified';
            break;
          case 'pending_microdeposits':
          case 'pending':
            displayStatus = 'pending verification';
            break;
          default:
            displayStatus = normalized.status || 'unknown';
            break;
          }

          normalized.displayStatus = displayStatus;
          normalized.display
            = `${normalized.bank_name} ending in ${normalized.last4} (${displayStatus})`;

          // Set as selected if this is the new account
          if(newAccount && newAccount.id === normalized.id) {
            modalvm.selectedAccount = normalized;
            // Only enable pay button if account is verified
            normalized.status === 'verified'
              ? enablePayButton() : disablePayButton();
          }

          accounts.push(normalized);
        }

        accounts.push({id: 'new', display: 'Add New Bank Account'});
        modalvm.accounts = accounts;
        LoaderSvc.stop();
      })
        .catch(function(e) {
          console.error('Error loading saved cards:', e);
          modalvm.accountError = true;
          LoaderSvc.stop();
        });
    }

    modalvm.checkAccount = function() {
      // NOTE: account.id: 'new' => Create; status: 'pending*' => Verify
      // create new account
      if(modalvm.selectedAccount && modalvm.selectedAccount.id === 'new') {
        delete modalvm.selectedAccount;
        NewAccountModalSvc.open().then(_loadSavedAccounts);
      } else if(
        modalvm.selectedAccount
        && (modalvm.selectedAccount.status === 'pending_microdeposits'
            || modalvm.selectedAccount.status === 'pending')
      ) {
        // if account with pending verification status, open verification modal
        VerifyAccountModalSvc
          .open(modalvm.selectedAccount)
          .then(_loadSavedAccounts);
      }
      // enable pay button only for verified accounts
      modalvm.selectedAccount
      && modalvm.selectedAccount.status === 'verified'
        ? enablePayButton()
        : disablePayButton();
    };

    ////////////////////////////////////////////////////////////////////////////
    ///  OFFLINE PAYMENTS
    ////////////////////////////////////////////////////////////////////////////
    function _submitOfflinePayment() {
      LoaderSvc.start();
      FinTxnSvc.submit({groupId}, modalvm.finTxn).$promise
        .then(function(data) {
          LoaderSvc.stopSuccess('Offline Payment Submitted');
          modalInstance.close(data);
        })
        .catch(function(e) {
          LoaderSvc.stopError(e);
          modalInstance.close();
        });
    }

    ////////////////////////////////////////////////////////////////////////////
    ///  Submit Payment
    ////////////////////////////////////////////////////////////////////////////
    function onSubmit() {
      LoaderSvc.start();
      disablePayButton();
      /**
       * TODO: ensure the amount is non-zero before submitting
       */
      modalvm.submitted = true;
      // add processing fee if necessary
      if(finTxn.isIncreasedByFee) {
        // include new line at beginning
        finTxn.description += `\n ${finTxn.feeDescription} - $${finTxn.processFeeAmount / 100}`;
      }

      switch (finTxn.type) {
      case 'card':
        _submitSavedCardPayment();
        break;
      case 'account':
        _submitSavedAccountPayment();
        break;
      case 'offline':
        _submitOfflinePayment();
        break;
      default:
        break;
      }
    }

    function onCancel() {
      modalInstance.dismiss();
    }

    ////////////////////////////////////////////////////////////////////////////
    ///  Set Modal Scope
    ////////////////////////////////////////////////////////////////////////////
    var modalScope = {modalvm: angular.extend(modalvm,
      {
        dismissable: true,
        finTxn,
        // modal settings
        title: 'Payment Step 2: Select Payment Method',
        buttons
      })
    };

    var options = {size: 'lg', template};

    modalInstance = ModalSvc.open(modalScope, options);
    return modalInstance.result;
  }

  // Public API here
  return {
    open
  };
}

PaymentModalSvc.$inject = [
  'ModalSvc',
  'LoaderSvc',
  '$http',
  'FinTxnSvc',
  'StripeSvc',
  'moment',
  'NewCardModalSvc',
  'NewAccountModalSvc',
  'VerifyAccountModalSvc'
];

export default PaymentModalSvc;
